import { parseStatusDetails } from '../notificationparsers/notificationstatuses/notificationStatusParsers';

export function getNotificationSymbol(msg) {
  const notificationDetails = msg.notificationDetails ?? null;
  const status = msg.status ?? null;
  if (!notificationDetails || !status) return null;
  const statusDetails = parseStatusDetails(status, msg.statusDetails);
  if (statusDetails) {
    if (statusDetails.symbol) return statusDetails.symbol;
    else if (statusDetails.positionSymbol) return statusDetails.positionSymbol;
  }
  if (notificationDetails) {
    if (notificationDetails.TRADE_PLAN) {
      if (notificationDetails.TRADE_PLAN.symbol)
        return notificationDetails.TRADE_PLAN.symbol;
    }
  }
  return null;
}
